module.exports = __webpack_public_path__ + "static/media/IPALERJ.361df06e.svg";